import React, { useState, useEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { FaEye, FaHeart, FaTimesCircle, FaArrowLeft, FaCheck, FaLightbulb, FaArrowRight, FaArrowCircleLeft, FaArrowCircleRight, FaInfoCircle, FaChevronDown, FaChevronUp, FaEdit } from 'react-icons/fa';
import { BsStopwatch } from 'react-icons/bs';
import useAuth from "./useAuth";
import { useLocation, useNavigate } from 'react-router-dom';
import Sidebar from "./sidebar";
import NavBar from "./navbar";
import axios from 'axios';
import QuestionModal from '../administration/qcm/editeur_qcm';

const Demarrer_qcm = () => {
    useAuth();
    const location = useLocation();
    const [showInfo, setShowInfo] = useState(false);

    const [qcms, setQcms] = useState([]);
    const [alert, setAlert] = useState({ message: '', type: '' });
    const [answers, setAnswers] = useState({});
    const user_id = localStorage.getItem('user_id');
    const { evaluation_id } = location.state || {};
    const { etape_id } = location.state || {};
    const { tag } = location.state || {};
    const { _ts } = location.state || {};
    const navigate = useNavigate();

    // 🔧 FIX 1 : Timestamp avec partie aléatoire pour garantir l'unicité
    // (évite la collision si deux clics surviennent dans la même milliseconde)
    const generateTs = () => `${Date.now()}_${Math.random().toString(36).slice(2, 9)}`;

    // ✅ Timestamp de session unique : soit fourni par la navigation, soit généré
    const sessionTs = useMemo(() => _ts || generateTs(), [_ts]);

    // ✅ Clés localStorage uniques par session
    const answersKey = `answers_${evaluation_id}_${sessionTs}`;
    const currentQcmIndexKey = `currentQcmIndex_${evaluation_id}_${sessionTs}`;

    const [currentQcmIndex, setCurrentQcmIndex] = useState(0);
    const [selectedAnswer, setSelectedAnswer] = useState(null);
    const [explanationVisible, setExplanationVisible] = useState(false);
    const [feedbackVisible, setFeedbackVisible] = useState(false);
    const [isAnswerCorrect, setIsAnswerCorrect] = useState(null);
    const [favorites, setFavorites] = useState(new Set());
    const [isLoading, setIsLoading] = useState(false);
    const [langue, setLangue] = useState('Fr');

    const [textColor, setTextColor] = useState('#000000');
    const [bgColor, setBgColor] = useState('#ffffff');
    const [optionColors, setOptionColors] = useState({});
    const [showColorPicker, setShowColorPicker] = useState(false);

    useEffect(() => {
        if (user_id) {
            document.title = "eTrainApp | Demarrer";
        }
    }, [user_id]);

    const [showModal, setShowModal] = useState(false);

    const handleCloseModal = () => {
        setShowModal(false);
    };

    // ============================================================
    // FONCTION POUR AFFICHER LES QUESTIONS PAR CORRESPONDANCE
    // ============================================================
    const renderCorrespondanceQuestion = (qcm, currentQcmIndex) => {
        try {
            let leftOptions = [];
            let rightOptions = [];
            let pairs = {};

            // Parser option1 (items à gauche)
            if (typeof qcm.option1 === 'string') {
                try {
                    leftOptions = JSON.parse(qcm.option1);
                    if (!Array.isArray(leftOptions)) {
                        leftOptions = [];
                    }
                } catch (e) {
                    console.error('Erreur parsing option1:', e);
                    leftOptions = [];
                }
            } else if (Array.isArray(qcm.option1)) {
                leftOptions = qcm.option1;
            }

            // Parser option2 (correspondances à droite)
            if (typeof qcm.option2 === 'string') {
                try {
                    rightOptions = JSON.parse(qcm.option2);
                    if (!Array.isArray(rightOptions)) {
                        rightOptions = [];
                    }
                } catch (e) {
                    console.error('Erreur parsing option2:', e);
                    rightOptions = [];
                }
            } else if (Array.isArray(qcm.option2)) {
                rightOptions = qcm.option2;
            }

            pairs = qcm.reponse || {};

            // Récupérer les réponses sauvegardées
            const savedData = answers[String(qcm.id)] || {};
            const currentPairs = savedData.pairs || {};

            const handleCorrespondanceChange = (leftId, rightId) => {
                const newPairs = { ...currentPairs };
                if (!rightId) {
                    delete newPairs[leftId];
                } else {
                    newPairs[leftId] = Number(rightId);
                }

                const updatedAnswers = {
                    ...answers,
                    [String(qcm.id)]: {
                        type: 'correspondance',
                        pairs: newPairs
                    }
                };
                setAnswers(updatedAnswers);
                // ✅ Clé timestampée
                localStorage.setItem(answersKey, JSON.stringify(updatedAnswers));
            };

            if (!leftOptions || leftOptions.length === 0) {
                return <div className="text-danger">Aucun item à associer trouvé</div>;
            }

            if (!rightOptions || rightOptions.length === 0) {
                return <div className="text-danger">Aucune correspondance trouvée</div>;
            }

            return (
                <>
                    <style>{`
                    .correspondance-table {
                        width: 100%;
                        background: #f8f9fa;
                        border-radius: 5px;
                        border: 1px solid #e9ecef;
                        padding: 10px;
                        margin-top: 10px;
                    }
                    .correspondance-table td {
                        padding: 6px 10px;
                        vertical-align: middle;
                        border-bottom: 1px solid #e9ecef;
                        text-align: left !important;
                    }
                    .correspondance-table tr:last-child td {
                        border-bottom: none;
                    }
                    .correspondance-table .title-row td {
                        font-weight: 600;
                        font-size: 14px;
                        border-bottom: 2px solid #dee2e6;
                        padding-bottom: 10px;
                    }
                    .correspondance-table select {
                        font-size: 13px;
                        height: 32px;
                        width: 60px;
                        min-width: 60px;
                        border-radius: 4px;
                        border: 1px solid #ced4da;
                        padding: 2px 4px;
                        margin-right: 10px;
                        display: inline-block;
                    }
                    .correspondance-table .item-text {
                        font-size: 13px;
                        font-weight: 500;
                        display: inline-block;
                    }
                    .correspondance-table .numero {
                        font-size: 13px;
                        font-weight: 600;
                        margin-right: 5px;
                        display: inline-block;
                        min-width: 25px;
                    }
                    .correspondance-table .info-text {
                        margin-top: 10px;
                        font-size: 12px;
                        text-align: center;
                        color: #6c757d;
                    }
                    .correspondance-table .left-cell {
                        display: flex;
                        align-items: center;
                        justify-content: flex-start;
                    }
                    .correspondance-table .right-cell {
                        display: flex;
                        align-items: center;
                        justify-content: flex-start;
                    }
                `}</style>

                    <table className="correspondance-table">
                        <thead>
                            <tr className="title-row">
                                <td style={{ width: '50%' }}>
                                    {langue === 'Fr' ? 'Items à associer' : 'Items to match'}
                                </td>
                                <td style={{ width: '50%' }}>
                                    {langue === 'Fr' ? 'Correspondances' : 'Correspondences'}
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            {leftOptions.map((leftItem, index) => {
                                const currentPair = currentPairs[leftItem.id] || '';
                                let selectedIndex = '';
                                if (currentPair) {
                                    const foundIndex = rightOptions.findIndex(item => item.id === currentPair);
                                    if (foundIndex !== -1) {
                                        selectedIndex = foundIndex + 1;
                                    }
                                }
                                const rightItem = rightOptions[index] || {};
                                const numero = index + 1;
                                return (
                                    <tr key={leftItem.id || index}>
                                        <td>
                                            <div className="left-cell">
                                                <select
                                                    value={selectedIndex}
                                                    onChange={(e) => {
                                                        const selectedValue = e.target.value;
                                                        if (selectedValue === '') {
                                                            handleCorrespondanceChange(leftItem.id, '');
                                                        } else {
                                                            const rightId = rightOptions[parseInt(selectedValue) - 1]?.id;
                                                            if (rightId) {
                                                                handleCorrespondanceChange(leftItem.id, rightId);
                                                            }
                                                        }
                                                    }}
                                                >
                                                    <option value="">-</option>
                                                    {rightOptions.map((item, idx) => (
                                                        <option key={item.id} value={idx + 1}>
                                                            {idx + 1}
                                                        </option>
                                                    ))}
                                                </select>
                                                <span className="item-text">{leftItem.value || `Item ${index + 1}`}</span>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="right-cell">
                                                <span className="numero">{numero}.</span>
                                                <span className="item-text">{rightItem.value || `Correspondance ${rightItem.id}`}</span>
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>

                </>
            );
        } catch (e) {
            console.error('Erreur rendu correspondance:', e);
            return <div className="text-danger">Erreur d'affichage des correspondances: {e.message}</div>;
        }
    };
    // ============================================================
    // FIN FONCTION CORRESPONDANCE
    // ============================================================

    const handleDemarrer = async () => {
        try {
            const response = await fetch(
                `${process.env.REACT_APP_HOTE}/demarrer-evaluation/${user_id}/${evaluation_id}/`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );
            if (response.ok) {
                fetchSimulations()
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };

    const handleFinishSimulation = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/enregistrer-reponses-qcm-evaluation/${user_id}/${evaluation_id}/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    answers: answers
                }),
            });
            const response2 = await fetch(`${process.env.REACT_APP_HOTE}/pourcentage-evaluation/${user_id}/${evaluation_id}/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    etape_id: etape_id
                }),
            });
            if (!response2.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response2.json();

            if (response.ok) {
                // ✅ Supprimer uniquement la session courante
                localStorage.removeItem(answersKey);
                localStorage.removeItem(currentQcmIndexKey);

                const terminerEtapeResponse = await fetch(
                    `${process.env.REACT_APP_HOTE}/terminer-etape-utilisateur/${user_id}/${etape_id}/`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                    }
                );

                if (!terminerEtapeResponse.ok) {
                    const data = await terminerEtapeResponse.json();
                    setIsLoading(false);
                }
                navigate(`/terminer-qcm`, {
                    state: { evaluation_id: evaluation_id },
                });
            } else {
                const data = await response.json();
                showAlert('Veuillez repondre aux questions', 'danger')
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };

    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        setTimeout(() => {
            setAlert({ message: '', type: '' });
        }, 5000);
    };

    // ✅ Sauvegarde de l'index courant avec la clé timestampée
    useEffect(() => {
        if (qcms.length > 0) {
            localStorage.setItem(currentQcmIndexKey, currentQcmIndex);
        }
    }, [currentQcmIndex, qcms, currentQcmIndexKey]);

    const fetchSimulations = async () => {
        setIsLoading(true)
        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/recuperer-evaluation-qcms/${user_id}/${evaluation_id}/`);
            if (response.ok) {
                const data = await response.json();
                setQcms(data.qcms);
                setIsLoading(false)
                // ✅ Lecture de l'index avec la clé timestampée
                const savedStep = localStorage.getItem(currentQcmIndexKey);
                if (savedStep) {
                    const step = Number(savedStep);
                    if (step >= 0 && step < data.qcms.length) {
                        setCurrentQcmIndex(step);
                    } else {
                        setCurrentQcmIndex(0);
                    }
                }
            } else {
                setIsLoading(false)
            }
        } catch (error) {
        }
    };

    useEffect(() => {
        fetchSimulations();
    }, [user_id, evaluation_id]);

    const handleModifierLangue = async () => {
        const nouvelleLangue = langue === "Fr" ? "Ang" : "Fr";
        setLangue(nouvelleLangue);

        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/modifier-langue-evaluation/${evaluation_id}/${user_id}/`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ langue: nouvelleLangue, tag: tag })
            });

            const data = await response.json();
            if (response.ok) {
                try {
                    const demarrerResponse = await fetch(
                        `${process.env.REACT_APP_HOTE}/demarrer-evaluation/${user_id}/${evaluation_id}/`,
                        {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                        }
                    );
                    const demarrerData = await demarrerResponse.json();
                    if (demarrerResponse.ok) {
                        fetchSimulations()
                    } else {
                        console.log(demarrerData)
                    }
                } catch (error) {
                    console.error("Erreur lors de la requête :", error);
                }
            } else {
                showAlert(data.error, 'danger');
                setLangue("Fr");
            }
        } catch (error) {
            console.error("Erreur lors de la requête :", error);
        }
    };

    // ✅ Restauration des réponses avec la clé timestampée
    // 🔧 FIX 2 : Nettoyage des anciennes clés legacy ('answers' sans timestamp)
    // Ces clés peuvent provenir d'anciennes versions du code et polluer
    // les nouvelles sessions en injectant des réponses obsolètes.
    useEffect(() => {
        // 🔧 FIX 2 : Supprimer les anciennes clés non timestampées
        localStorage.removeItem('answers');
        localStorage.removeItem('currentQcmIndex');

        const savedAnswers = localStorage.getItem(answersKey);
        if (savedAnswers) {
            setAnswers(JSON.parse(savedAnswers));
        } else {
            // Nouvelle session : reset
            setAnswers({});
        }
    }, [answersKey]);

    const handleNextQcm = () => {
        if (currentQcmIndex < qcms.length - 1) {
            setCurrentQcmIndex(currentQcmIndex + 1);
            setExplanationVisible(false);
            setFeedbackVisible(false);
            setIsAnswerCorrect(null);
            setSelectedAnswer(null); // ✅ reset du feedback
        }
    };

    const handlePreviousQcm = () => {
        if (currentQcmIndex > 0) {
            setCurrentQcmIndex(currentQcmIndex - 1);
            setExplanationVisible(false);
            setFeedbackVisible(false);
            setIsAnswerCorrect(null);
            setSelectedAnswer(null); // ✅ reset du feedback
        }
    };

    const handleMultipleAnswerChange = (qcmId, option, isChecked) => {
        const qcm = qcms.find(q => q.id === qcmId);
        if (qcm?.type_question === 'correspondance') {
            return;
        }

        setAnswers(prevAnswers => {
            const isMultipleChoice = qcms.find(qcm => qcm.id === qcmId)?.reponse.length > 1;
            const key = String(qcmId);

            let newAnswers;
            if (isMultipleChoice) {
                const currentAnswers = prevAnswers[key] || [];
                const updatedAnswers = isChecked
                    ? [...currentAnswers, option]
                    : currentAnswers.filter(answer => answer !== option);
                newAnswers = {
                    ...prevAnswers,
                    [key]: updatedAnswers,
                };
            } else {
                newAnswers = {
                    ...prevAnswers,
                    [key]: isChecked ? [option] : [],
                };
            }

            // ✅ Persister avec la clé timestampée
            localStorage.setItem(answersKey, JSON.stringify(newAnswers));

            return newAnswers;
        });
    };

    const [accesGroupe, setAccesGroupe] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupe(JSON.parse(accesGroupeStored));
        } else {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupe(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                // console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} />
            <div id="page-wrapper" className="gray-bg">
                <NavBar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <div className='row align-items-end'>
                                <h2>
                                    <BsStopwatch size={25} className="mr-2" />Evaluation
                                </h2>
                                <span
                                    className="ml-3 toggle-icon"
                                    style={{ cursor: 'pointer', marginBottom: '10px' }}
                                    onClick={() => setShowInfo(!showInfo)}
                                >
                                    {showInfo ? <FaChevronUp /> : <FaChevronDown />}
                                </span>
                            </div>

                            <div className={`info-box ${showInfo ? "open" : ""}`}>
                                <small>
                                    Pour chaque QCM, une seule réponse est possible. Cochez la bonne réponse. Utilisez les boutons pour une meilleure gestion des QCM.
                                    <br />
                                    <b>Légende des icônes : </b>
                                    <FaEye className="ivt-align-menu" /> indique que la question a été déjà vue.
                                    <FaHeart className="ivt-align-menu" /> indique que la question est mise en favoris; dans ce cas cliquez sur le menu Simulateur &gt; Favoris.
                                    <br />
                                    Le bouton <FaTimesCircle className="ivt-align-menu" /> permet de terminer une simulation.
                                    Le bouton <FaArrowLeft className="ivt-align-menu" /> permet d'aller sur la question précédente.
                                    Le bouton <FaCheck className="ivt-align-menu" /> permet de vérifier si la réponse choisie est correcte.
                                    Le bouton <FaLightbulb className="ivt-align-menu" /> permet d'afficher le corrigé type d'une question.
                                    Le bouton <FaArrowRight className="ivt-align-menu" /> permet d'aller sur la question suivante.
                                </small>
                            </div>

                            <small id="hbreadcrumb" className="d-flex justify-content-end">
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Parcours`}> Parcours </Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        {evaluation_id}
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    {alert.message && (
                        <div className={`mt-3 alert alert-${alert.type}`}>
                            {alert.message}
                        </div>
                    )}

                    <div className="wrapper wrapper-content animated fadeInRight mt-3">
                        <div className="row d-flex justify-content-center">
                            <div className="col-lg-8 mx-auto">
                                <div className="ibox">
                                    <div className="ibox-title pr-3">
                                        <tr className='d-flex justify-content-between align-items-center'>
                                            <div className='d-flex'>
                                                <td className='badge badge-secondary'> {qcms[currentQcmIndex]?.ref} </td>
                                                <td>
                                                    {qcms[currentQcmIndex]?.deja_vu === "oui" && (
                                                        <i className="ml-1 fa fa-eye" title="Déjà vu"></i>
                                                    )}
                                                </td>
                                                <td>
                                                    {qcms[currentQcmIndex]?.favoris === "oui" && (
                                                        <i className="ml-1 fa fa-heart" title="Favoris"></i>
                                                    )}
                                                </td>
                                                {favorites.has(qcms[currentQcmIndex]?.id) && (
                                                    <i className="ml-1 fa fa-heart" title="Favoris"></i>
                                                )}
                                            </div>
                                            <td>
                                                {qcms.length > 0 ? `${currentQcmIndex + 1} sur ${qcms.length}` : "0 sur 0"}
                                            </td>
                                            <td className='d-flex'>
                                                <button
                                                    className="btn btn-outline btn-secondary btn-sm mr-2"
                                                    onClick={() => setShowColorPicker(!showColorPicker)}
                                                    title="Personnaliser les couleurs"
                                                >
                                                    <i className="fa fa-paint-brush"></i>
                                                </button>

                                                {showColorPicker && (
                                                    <div className="color-palette" style={{
                                                        position: 'absolute',
                                                        top: '100%',
                                                        right: '10',
                                                        zIndex: 1000,
                                                        backgroundColor: 'white',
                                                        border: '1px solid #ddd',
                                                        borderRadius: '5px',
                                                        padding: '10px',
                                                        boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                                                        width: '250px'
                                                    }}>
                                                        <div className="mb-2">
                                                            <label className="small">Couleur du texte:</label>
                                                            <input
                                                                type="color"
                                                                className="form-control form-control-color"
                                                                value={textColor}
                                                                onChange={(e) => setTextColor(e.target.value)}
                                                                style={{ width: '100%', height: '40px' }}
                                                            />
                                                        </div>

                                                        <div className="mb-2">
                                                            <label className="small">Couleur de fond:</label>
                                                            <input
                                                                type="color"
                                                                className="form-control form-control-color"
                                                                value={bgColor}
                                                                onChange={(e) => setBgColor(e.target.value)}
                                                                style={{ width: '100%', height: '40px' }}
                                                            />
                                                        </div>

                                                        <div className="mt-2 text-right">
                                                            <button
                                                                className="btn btn-sm btn-secondary mr-2"
                                                                onClick={() => {
                                                                    setShowColorPicker(false);
                                                                }}
                                                            >
                                                                Fermer
                                                            </button>
                                                            <button
                                                                className="btn btn-sm btn-secondary"
                                                                onClick={() => {
                                                                    setTextColor('#000000');
                                                                    setBgColor('#ffffff');
                                                                    setOptionColors({});
                                                                }}
                                                            >
                                                                Réinitialiser
                                                            </button>
                                                        </div>
                                                    </div>
                                                )}
                                                <div className="mr-2 d-flex">
                                                    <Button
                                                        className="btn btn-outline btn-secondary btn-sm"
                                                        onClick={() => {
                                                            const elements = document.querySelectorAll('.ibox-content, .ibox-content *');
                                                            elements.forEach(element => {
                                                                const currentSize = parseInt(window.getComputedStyle(element).fontSize);
                                                                element.style.fontSize = `${currentSize + 1}px`;
                                                            });
                                                        }}
                                                        title="Zoomer"
                                                    >
                                                        <i className="fa fa-search-plus"></i>
                                                    </Button>
                                                    <Button
                                                        className="btn btn-outline btn-secondary btn-sm ml-1"
                                                        onClick={() => {
                                                            const elements = document.querySelectorAll('.ibox-content, .ibox-content *');
                                                            elements.forEach(element => {
                                                                const currentSize = parseInt(window.getComputedStyle(element).fontSize);
                                                                element.style.fontSize = `${Math.max(12, currentSize - 1)}px`;
                                                            });
                                                        }}
                                                        title="Dézoomer"
                                                    >
                                                        <i className="fa fa-search-minus"></i>
                                                    </Button>
                                                </div>
                                                {accesGroupe.includes("Administration") &&
                                                    <Button className='mr-2' onClick={() => setShowModal(true)}>
                                                        <FaEdit />
                                                        {showModal && currentQcmIndex !== null && (
                                                            <QuestionModal
                                                                show={showModal}
                                                                handleClose={handleCloseModal}
                                                                qcm_ref={qcms[currentQcmIndex]?.unicite}
                                                                user_id={user_id}
                                                                reussite={handleDemarrer}
                                                            />
                                                        )}
                                                    </Button>
                                                }
                                                <button className="btn btn-outline btn-warning" onClick={handleFinishSimulation}>
                                                    <i className="fa fa-times-circle mr-1"></i>
                                                    <span className="d-none d-sm-inline">
                                                        Terminer l'Evaluation
                                                    </span>
                                                </button>
                                            </td>
                                        </tr>
                                    </div>
                                    {!isLoading ? (
                                        <div className="ibox-content" style={{
                                            backgroundColor: bgColor,
                                            transition: 'all 0.3s ease'
                                        }}>
                                            {qcms.length > 0 ? (
                                                <form>
                                                    <input type="hidden" name="qcmidhidden" id="qcmidhidden" value={qcms[currentQcmIndex]?.id} />
                                                    <div
                                                        id="question"
                                                        style={{
                                                            fontSize: '12px',
                                                            color: textColor
                                                        }}
                                                        dangerouslySetInnerHTML={{ __html: qcms[currentQcmIndex]?.question }}
                                                    ></div>

                                                    {/* Affichage selon le type de question */}
                                                    {qcms[currentQcmIndex]?.type_question === 'correspondance' ? (
                                                        renderCorrespondanceQuestion(qcms[currentQcmIndex], currentQcmIndex)
                                                    ) : (
                                                        // Questions par défaut
                                                        <div style={{ margin: '10px 10px' }}>
                                                            {Object.keys(qcms[currentQcmIndex])
                                                                .filter(key => key.startsWith('option') && qcms[currentQcmIndex][key] && (qcms[currentQcmIndex][key] !== 'non défini' && qcms[currentQcmIndex][key] !== 'vide'))
                                                                .map((key, index) => {
                                                                    const optionLetter = String.fromCharCode(65 + index);
                                                                    const isMultipleChoice = qcms[currentQcmIndex].reponse.length > 1;
                                                                    // ✅ Utiliser String() pour la clé
                                                                    const isOptionChecked = answers[String(qcms[currentQcmIndex].id)]?.includes(optionLetter);
                                                                    const optionColor = optionColors[optionLetter] || textColor;

                                                                    return (
                                                                        <div className="checkbox" key={key} style={{
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            marginBottom: '10px',
                                                                            backgroundColor: isOptionChecked ? 'rgba(0,123,255,0.1)' : 'transparent',
                                                                            padding: '5px',
                                                                            borderRadius: '5px'
                                                                        }}>
                                                                            <label style={{
                                                                                margin: 0,
                                                                                fontSize: '12px',
                                                                                cursor: 'pointer',
                                                                                color: optionColor,
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                width: '100%'
                                                                            }}>
                                                                                <input
                                                                                    type={isMultipleChoice ? "checkbox" : "radio"}
                                                                                    name={`qcmitem-${qcms[currentQcmIndex].id}`}
                                                                                    value={optionLetter}
                                                                                    className="i-checks choix"
                                                                                    style={{ marginRight: '10px', cursor: 'pointer' }}
                                                                                    onChange={(e) => handleMultipleAnswerChange(qcms[currentQcmIndex].id, optionLetter, e.target.checked)}
                                                                                    checked={isOptionChecked}
                                                                                />
                                                                                <span style={{ fontWeight: isOptionChecked ? 'bold' : 'normal', marginRight: '5px' }}>
                                                                                    {optionLetter} -
                                                                                </span>
                                                                                <span
                                                                                    id={`option${index + 1}`}
                                                                                    style={{
                                                                                        color: optionColor,
                                                                                        fontWeight: isOptionChecked ? 'bold' : 'normal'
                                                                                    }}
                                                                                >
                                                                                    {qcms[currentQcmIndex][key]}
                                                                                </span>

                                                                                {feedbackVisible &&
                                                                                    selectedAnswer?.qcmId === qcms[currentQcmIndex].id &&
                                                                                    selectedAnswer.value.includes(optionLetter) &&
                                                                                    !explanationVisible && (
                                                                                        qcms[currentQcmIndex].reponse.includes(optionLetter) ? (
                                                                                            <i
                                                                                                className="fa fa-thumbs-o-up fa-2x ivt-align-menu"
                                                                                                style={{ color: 'green', marginLeft: '5px' }}
                                                                                                title="Correct">
                                                                                            </i>
                                                                                        ) : (
                                                                                            <i
                                                                                                className="fa fa-thumbs-o-down fa-2x ivt-align-menu"
                                                                                                style={{ color: 'red', marginLeft: '5px' }}
                                                                                                title="Incorrect">
                                                                                            </i>
                                                                                        )
                                                                                    )}

                                                                                {explanationVisible &&
                                                                                    qcms[currentQcmIndex].reponse.includes(optionLetter) && (
                                                                                        <i
                                                                                            className="fa fa-thumbs-o-up fa-2x ivt-align-menu"
                                                                                            style={{ color: 'green', marginLeft: '5px' }}
                                                                                            title="Correct Answer">
                                                                                        </i>
                                                                                    )}
                                                                            </label>
                                                                        </div>
                                                                    );
                                                                })}
                                                        </div>
                                                    )}

                                                    {explanationVisible && qcms[currentQcmIndex].explication != 'Non défini' && (
                                                        <div className='d-flex' style={{ color: 'green' }}>
                                                            <div style={{ color: 'green' }}>
                                                                <span>Explication : </span>
                                                                <span dangerouslySetInnerHTML={{ __html: qcms[currentQcmIndex].explication }} />
                                                            </div>
                                                        </div>
                                                    )}
                                                </form>
                                            ) : (
                                                <p>Aucun QCM trouvé.</p>
                                            )}
                                        </div>
                                    ) : (
                                        <div className="mt-3 d-flex justify-content-center align-items-center" style={{ height: '100%', width: '100%' }}>
                                            <span
                                                className="spinner-border spinner-border-lg text-success"
                                                role="status"
                                                aria-hidden="true"
                                                style={{ width: '3rem', height: '3rem' }}
                                            ></span>
                                        </div>
                                    )}
                                    <div className="ibox-footer d-flex justify-content-end flex-wrap gap-2">
                                        <div className="ml-1">
                                            <Button
                                                onClick={handlePreviousQcm}
                                                style={{ display: currentQcmIndex === 0 ? 'none' : 'block' }}
                                                className="btn btn-outline btn-success"
                                            >
                                                <FaArrowCircleLeft className="me-1 mr-1" />
                                                <span className='labelInfo1'>Précédent</span>
                                            </Button>
                                        </div>
                                        <div className="ml-1">
                                            <Button
                                                onClick={handleNextQcm}
                                                style={{ display: currentQcmIndex === qcms.length - 1 ? 'none' : 'block' }}
                                                className="btn btn-outline btn-success"
                                            >
                                                <span className='labelInfo1'>Suivant</span>
                                                <FaArrowCircleRight className="me-1 ml-1" />
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Demarrer_qcm;